<script>
  import { dataStore } from '../stores/source';

  export let value = "";
  export let rowIndex;
  export let rowId;
  export let instructKey;
</script>

<button class="btn btn-link" on:click={function() {
   console.log(rowIndex);
   console.log(rowId);
   console.log($dataStore[rowIndex]);
   window.openModal({
      type: "modal",
      data: {
        view: "item",
        feature: {
          properties: $dataStore[rowIndex],
          geometry: $dataStore[rowIndex].geometry
        },
      }
    });
}}>
  View
</button>